module.exports = __webpack_public_path__ + "img/img-01.21aa025c.png";